
export enum LabelTreeViewMode {
    FLAT = "FLAT",
    FOLDERS = "FOLDERS",
}
